import React, { Fragment } from "react";

import AssociadoEspecial from "../AssociadoEspecial";
import ParenteParticipante from "../ParenteParticipante";
import Participante from "../Participante";

interface Props {
  nextStep?: Function;
  previousStep?: Function;
}

const TipoParticipante: React.FC<Props> = ({ nextStep, previousStep }) => {
  const tipoParticipante = sessionStorage.getItem(
    "@RealizePrev:tipoParticipante"
  );

  return (
    <Fragment>
      {tipoParticipante === "Participante" ? (
        <Participante
          nextStep={nextStep ? nextStep : () => {}}
          previousStep={previousStep ? previousStep : () => {}}
        />
      ) : tipoParticipante === "ParenteParticipante" ? (
        <ParenteParticipante
          nextStep={nextStep ? nextStep : () => {}}
          previousStep={previousStep ? previousStep : () => {}}
        />
      ) : (
        <AssociadoEspecial
          nextStep={nextStep ? nextStep : () => {}}
          previousStep={previousStep ? previousStep : () => {}}
        />
      )}
    </Fragment>
  );
};
export default TipoParticipante;
